<template>
  <button :class="[getClassName(docStatus, isMine)]" v-bind="$attrs">
    <div class="flex flex-row">
      <template v-if="!docType">
        <div>
          <slot name="buttonText"> </slot>
        </div>
        <img
          :src="getIcon(docStatus)"
          width="20"
          height="20"
          class="ml-1 mr-1"
        />
        <app-document-status-text
          color="blue"
          :status="docStatus"
          :isMine="isMine"
        ></app-document-status-text>
      </template>
      <template v-else>
        <img
          :src="getIcon(docStatus)"
          width="20"
          height="20"
          class="ml-1 mr-1"
        />
        <div v-if="docType == 3">
          <span class="font-bold ml-1 to-action text-lg">行 </span>
          <span class="font-bold to-action text-sm">程</span>
        </div>
        <div v-if="docType == 4">
          <span class="font-bold ml-1 to-action text-lg">概 </span>
          <span class="font-bold to-action text-sm">要</span>
        </div>
        <div v-if="docType == 5">
          <span class="font-bold ml-1 to-action text-lg">費 </span>
          <span class="font-bold to-action text-sm">用</span>
        </div>
      </template>
    </div>
  </button>
</template>

<script>
import { toRef } from 'vue'
import AppDocumentStatusText from '@/components/ui/uiToda/AppDocumentStatusTextToda'
import { useStatus } from '@/services/politicalActionToda/useStatus'

export default {
  name: 'AppDocumentStatusButton_TODA',

  components: {
    AppDocumentStatusText,
  },

  props: {
    status: {
      type: Number,
      default: null,
    },
    docType: {
      type: Number,
      default: null,
    },
    isMine: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const docStatus = toRef(props, 'status')
    const { getClassName, getIcon } = useStatus()

    return { docStatus, getClassName, getIcon }
  },
}
</script>

<style lang="scss" scoped>
.to-action {
  color: #2993ce;
}
.bg-blue {
  span {
    color: #ffffff;
  }
}
</style>
